module.exports = __webpack_public_path__ + "img/contracts-colored.0e7a57e5.svg";